module.exports = __webpack_public_path__ + "static/img/icon_set.eca6f75e.png";